import Script from 'next/script';
import { Page } from '@thisisdevelopment/heritage-core-library';
import styled from 'styled-components';
import Head from 'next/head';
import Link from 'next/link';

const NestedParagraph = styled.span`
  display: block;
  margin-bottom: 20px;
`;

export default function Newsletter() {
  return (
    <>
      <Head>
        <title>Dulux Heritage Prize Draw</title>
      </Head>
      <Page
        title="Winter Prize Bundle Competition"
        headline={
          <>
            <NestedParagraph>Thank you for entering.</NestedParagraph>
            <NestedParagraph>
              If you have subscribed to our email newsletter, make sure you check your inbox for our
              confirmation email in the next few days. Find out more about Dulux Heritage{' '}
              <Link href="/">here</Link>.
            </NestedParagraph>
          </>
        }
        image={{
          url: 'https://datahose-cms.akzonobel.hosting/eukher/assets/odjjllj9gao400go',
          alt: 'Winter prize bundle competition',
        }}
      >
        <div style={{ height: '120px' }} />
        <Script id="fb-pixel" strategy="afterInteractive">
          {`
            !function(f,b,e,v,n,t,s) {
              if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1632094923699192');
            fbq('track', 'PageView');
          `}
        </Script>
      </Page>
    </>
  );
}
